import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";
import moment from "moment";
import { text } from "@topology/core";

export default function Ocharts({ data }) {
  const domRef = useRef(null); // 挂载节点
  const chartRef = useRef(null); // echarts 实例

  /* 统一处理窗口resize */
  useEffect(() => {
    const resize = () => chartRef.current?.resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  /* 核心：每当 data 变化时重新渲染 */
  useEffect(() => {
    if (!data?.data) return;

    /* 1. 初始化或复用实例 */
    if (!chartRef.current) {
      chartRef.current = echarts.init(domRef.current);
    }

    /* 2. 按原逻辑整理数据 */
    const day = [];
    const cod = [],
      tn = [],
      nh3n = [],
      tp = [],
      ss = [];

    Object.keys(data.data).forEach((key) =>
      data.data[key].forEach((item) => {
        day.push(moment(item.createTime).format("MM-DD HH:mm"));
        const { value, type } = item;
        if (type === 1) cod.push(value);
        else if (type === 2) tn.push(value);
        else if (type === 3) nh3n.push(value);
        else if (type === 4) tp.push(value);
        else if (type === 7) ss.push(value);
      })
    );

    const newday = day.filter((x, idx, arr) => arr.indexOf(x) === idx);

    /* 3. 图表配置（与原配置完全一致） */
    const option = {
      // backgroundColor: "#fff",
      color: ["#73A0FA", "#73DEB3", "#9013FE", "#FFB761"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: { color: "#999" },
          lineStyle: { type: "dashed" },
        },
      },
      grid: {
        left: 25,
        right: 25,
        bottom: 44,
        top: 85,
        containLabel: true,
      },
      legend: {
        data: ["COD", "TN", "NH3_N", "TP"],
        orient: "horizontal",
        icon: "rect",
        show: true,
        textStyle:{color:'#fff'}
      },
      xAxis: {
        type: "category",
        data: newday,
        splitLine: { show: false },
        axisTick: { show: false },
        axisLine: { show: false },
      },
      // dataZoom: [
      //   { type: "inside", start: 0, end: 100 },
      //   { start: 0, end: 100 },
      // ],
      yAxis: {
        type: "value",
        name: "mg/L",
        axisLabel: { color: "#999", fontSize: 12 },
        splitLine: {
          show: true,
          lineStyle: { color: "#F3F4F4" },
        },
        axisTick: { show: false },
        axisLine: { show: false },
      },
      series: [
        { name: "COD", type: "line", smooth: true, data: cod },
        { name: "TN", type: "line", smooth: true, data: tn },
        { name: "NH3_N", type: "line", smooth: true, data: nh3n },
        { name: "TP", type: "line", smooth: true, data: tp },
      ],
    };

    chartRef.current.setOption(option);

    /* 4. 组件卸载时销毁实例 */
    return () => {
      chartRef.current?.dispose();
      chartRef.current = null;
    };
  }, [data]);

  return (
    <div id="ocharts" ref={domRef} style={{ width: "100%", height: "100%" }} />
  );
}
